import { Switch } from '@components/Switch/Switch';
import { Tooltip } from '@mui/material';
import { trackingStore } from '@stores/Tracking';
import { useUIPreferences } from '@stores/UIPreferences';
import { observer } from 'mobx-react';
import { useId } from 'react';
import css from './AutoplayToggle.module.scss';

/**
 * "Autoplay" and a switch, on the gallery's search line. A word and a switch say what this is and
 * which way it's set, which the lightning-bolt circle it replaces in the header didn't: a bolt
 * isn't self-evidently about autoplay, and struck through or not is hard to read at 20px. The
 * header had no room for the word; this line does.
 *
 * Gallery only. List view plays nothing on hover, so the switch would do nothing there. A phone has
 * its switch in `MobileViewOptions`.
 */
export const AutoplayToggle = observer(() => {
  const uiPreferences = useUIPreferences();
  const id = useId();

  return (
    <Tooltip title="Play media while you point at it" arrow placement="top">
      <div className={css.autoplay}>
        <label htmlFor={id} className={css.label}>
          Autoplay
        </label>
        <Switch
          id={id}
          checked={uiPreferences.autoplayVideos}
          isLoading={uiPreferences.isLoading}
          onChange={() => {
            uiPreferences.toggleAutoplayVideos();
            // Tracks the NEW value after toggle (i.e. what the user switched TO)
            trackingStore.autoplayToggled({
              type: 'videos',
              enabled: uiPreferences.autoplayVideos,
            });
          }}
        />
      </div>
    </Tooltip>
  );
});
